import { Range } from '../entities/range.model';
import { DropDownItem } from '../../fields/dropdown-item.model';
import { Field } from '../entities/field.model';


export class TaxonomyCell {
    constructor(
        public id: string,
        public range: Range,
        public field: Field,
        public value: any,
        public isInRange: boolean,
        public valueChanged: boolean,
        public itemsChanged: boolean,
        public allItems: DropDownItem[],
        public items: DropDownItem[]) { }
}
